/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:04:41
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-08-01 09:57:09
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\product_price\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import feeBudget from './feeBudgetList.vue';

formCreate.component('feeBudget', feeBudget);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formParentCode: 'CRM20260728000000003',
      buttonText: {
        submit: '暂存',
        close: '关闭',
        submitAudit: '提交',
      },
      buttons: {
        submit: true,
        close: true,
        submitAudit: true,
      },
    };
  },
  async created() {
    await this.getFormRule('main-form', this.formParentCode);
  },
  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      if (v.field === 'transferType') {
        v.on = {
          ...v.on,
          change: (e) => {
            const feeBudgetList = this.getRule('feeBudget');
            feeBudgetList.props = {
              ...feeBudget.feeBudgetList,
              transferType: e,
            };
            this.setValue({
              feeBudget: {
                detailBudgetList: [],
                feeBudgetList: [],
              },
            });
          },
        };
      }
      if (v.field === 'fileBudgetList') {
        v.props = {
          ...v.props,
          fileMsg: '只能上传pdf/word/excel/ppt/png/jpg文件',
          accept: '.pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,.png,.jpg',
        };
      }
      return v;
    },
    // 渲染完成后执行
    formComplete() {
      const {
        code,
      } = this.formConfig;
      const feeBudgetList = this.getRule('feeBudget');
      feeBudgetList.props.disabled = code === 'view';
      if (code === 'view' || code === 'edit') {
        request.get('/dms/dmsTransferBudget/findByCode', {
          code: this.formConfig.row.transferCode || this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            feeBudgetList.props.transferType = result.transferType;
            result.detailBudgetList.forEach((item) => {
              result.feeBudgetList.forEach((v) => {
                if (v.feeBudgetCode === item.feeBudgetCode) {
                  if (v.customerCode) {
                    item.cantOpen = true;
                  } else {
                    item.cantOpen = false;
                  }
                }
              });
            });
            this.setValue({
              ...result,
              feeBudget: {
                detailBudgetList: result.detailBudgetList,
                feeBudgetList: result.feeBudgetList,
              },
            });
          }
        });
      }
    },
    submit(index) {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/dms/dmsTransferBudget/add';
        const params = {
          ...formData,
          detailBudgetList: formData.feeBudget.detailBudgetList,
          feeBudgetList: formData.feeBudget.feeBudgetList,
          tempFlag: index === 1 ? 'Y' : 'N',
        };
        delete params.feeBudget;
        if (this.formConfig.code === 'edit') {
          url = '/dms/dmsTransferBudget/update';
          params.id = this.formConfig.row.id;
        }
        if (index === 1) {
          request.post(url, params).then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '操作成功',
              });
              this.$emit('onClose');
              this.$emit('onGetList');
            }
          });
        } else {
          this.$emit('submit', {
            row: {
              ...params,
            },
            submitUrl: url,
          });
        }
      }
    },
  },
};
